import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthModule } from '~/auth/auth.module';
import { ComponentModule } from '~/component/component.module';
import { CoreModule } from '~/core/core.module';
import { MessagingModule } from '~/messaging/messaging.module';
import { OrganizerSharedModule } from '~/organizer/shared/shared.module';

import { OrganizerMessagingPageContactComponent } from './components/pages/contact/contact.component';
import { OrganizerMessagePageInboxComponent } from './components/pages/inbox/inbox.component';
import { OrganizerMessagingRoutingModule } from './messaging-routing.module';

@NgModule({
  declarations: [
    OrganizerMessagePageInboxComponent,
    OrganizerMessagingPageContactComponent,
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    AuthModule,
    CommonModule,
    CoreModule,
    OrganizerMessagingRoutingModule,
    ComponentModule,
    OrganizerSharedModule,
    MessagingModule,
  ],
})
export class OrganizerMessagingModule {}
